// components/QueueEntryCard.tsx
import { observer } from 'mobx-react-lite';
import {
  Card,
  CardContent,
  Box,
  Avatar,
  Typography,
  useTheme,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { SseAttendanceNewStatusPayloadT } from 'types/shared/core/Attendance';

type QueueEntryCardPropsT = {
  entry: SseAttendanceNewStatusPayloadT;
};

const QueueEntryCard = observer(({ entry }: QueueEntryCardPropsT) => {
  const { student, teacher, classroom } = entry;
  const { palette } = useTheme();
  const iconSize = 48;
  return (
    <Card
      sx={{
        m: 1,
        flex: '1 0 25%',
        minHeight: 150,
        backgroundColor: palette.neutral?.[800],
        // make the card a flex container
        display: 'flex',
        flexDirection: 'column',
        // center CardContent vertically
        justifyContent: 'center',
        // optional: center cards in the grid cell
        alignItems: 'center',
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="center" alignItems="center">
          {/* student */}
          <Avatar
            src={student.profileUrl ?? undefined}
            sx={{ width: iconSize, height: iconSize }}
          />
          <Typography variant="subtitle1" ml={1} noWrap>
            {student.name}
          </Typography>

          {/* arrow */}
          <ArrowForwardIcon sx={{ mx: 1 }} />

          {/* teacher */}
          {teacher && (
            <>
              <Avatar
                src={teacher.profileUrl ?? undefined}
                sx={{ width: iconSize, height: iconSize }}
              />
              <Typography variant="subtitle1" ml={1} noWrap>
                {teacher.nickname}
              </Typography>
            </>
          )}
        </Box>

        {/* classroom */}
        {classroom && (
          <Typography
            variant="body1"
            color="textSecondary"
            align="center"
            mt={2}
          >
            교실: {classroom}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
});

export default QueueEntryCard;
